import { Skeleton } from "primereact/skeleton";

const TabListShimmer = () => {

  return (
    <>
   <div className="shimmer_ui shi_mx_dev_1">
    <span className="shimmer_rows shimmer_flex"> 
      {
        [...Array(5)].map((e, i) =>        
            <Skeleton className="c-skeleton" key={`TabListShiimer${i}`}></Skeleton>          
        )
      }
      </span>
    </div>
    </>
  );
};

export default TabListShimmer;
